<template>
<div class="chapter">
<div class="inner_page">
<div id="V4037epub-1.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT" id="toc_marker-2"><span class="char-style-override-2">Also by Sayed Kashua:</span></p>
<p class="BT-1st-para para-style-override-1"><span class="char-style-override-3">Dancing Arabs</span></p>
<p class="BT-1st-para para-style-override-2"><span class="char-style-override-3">Let It Be Morning</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4037epub-1.vue?03f7d36e